import { render, staticRenderFns } from "./oglBackground.vue?vue&type=template&id=7c5fd04b&scoped=true"
import script from "./oglBackground.vue?vue&type=script&lang=js"
export * from "./oglBackground.vue?vue&type=script&lang=js"
import style0 from "./oglBackground.vue?vue&type=style&index=0&id=7c5fd04b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5fd04b",
  null
  
)

export default component.exports